// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page',
    // #endregion
    // #region Properties
    props: {
        contextId: {
            type: String,
            required: true,
            default: ''
        },
        itemId: {
            type: String,
            required: false,
            default: ''
        },
        args: {
            type: Object,
            required: false
        },
        mode: {
            type: String,
            required: false,
            default: 'view'
        },
        isHosted: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({}),
    // #endregion
    // #region Constructor
    beforeMount() {
    },
    beforeUnmount() {
    },
    // #endregion
    // #region Computed
    computed: {
        _contextId() {
            if (this.isHosted) {
                return this.contextId;
            }
            else {
                return this.$route.params.contextID;
            }
        },
        _itemId() {
            if (this.isHosted) {
                return this.itemId;
            }
            else {
                return this.$route.params.itemID;
            }
        }
    },
    // #endregion
    // #region Core
    methods: {}
    // #endregion
});
// #endregion
